/** A1 indicative demotion primitives (UX spec D-2).
 *
 *  When a fault-tab result is computed from placeholder source-fault data
 *  (`indicative_only`), the panels demote it VISUALLY — data and API are
 *  unchanged: values grey out (`.indicative-muted` in index.css), status/PPE
 *  chips switch to the neutral variant, table headers carry the SETUP DATA
 *  watermark chip, and the banner states the task, not the jargon. */

/** Neutral (grey) chip classes used in place of colored status/PPE badge
 *  classes while a study is indicative. */
export const NEUTRAL_BADGE_CLASS = 'bg-gray-100 text-gray-500'

/** Grey used in place of per-value inline colors (stat cards, colored cells)
 *  while a study is indicative. Matches `.indicative-muted` (gray-400). */
export const INDICATIVE_VALUE_COLOR = '#9ca3af'

/** Task-oriented banner replacing the old "INDICATIVE ONLY — placeholder
 *  source-fault data" copy. Copy is EXACT from the UX spec (§4.Stage1.2) and
 *  shared by all four fault-tab panels. */
export function IndicativeBanner() {
  return (
    <div className="text-xs rounded border border-amber-300 bg-amber-50 text-amber-800 px-3 py-1.5">
      Fault magnitudes become real when utility source data is loaded for this
      substation — contact the engineer.
    </div>
  )
}

/** SETUP DATA watermark chip for the table/section headers of indicative
 *  panels. */
export function SetupDataChip() {
  return (
    <span
      className="inline-block align-middle ml-2 px-1.5 py-0.5 rounded border border-gray-300 bg-gray-100 text-gray-500 text-[10px] font-semibold tracking-wider"
      title="Placeholder source data — these values show how the analysis will work, not real results"
    >
      SETUP DATA
    </span>
  )
}
